import { MonetaryValue } from '@eversports/types-and-utils'

import { CourtBookableItem, EventBookableItem } from './BookableItem'
import { PaymentIntent, PaymentMethod, PaymentState } from './Payment'
import { AssignedProduct } from './Product'

interface Order {
  __typename: 'Order'
  id: string
  priceTable: PriceTable
  items?: Array<Item>
  isConfirmable?: boolean
  payment?: Payment | null
}

interface PriceTable {
  total: MonetaryValue | null
}

interface Payment {
  paymentMethods?: Array<PaymentMethod>
  paymentIntent?: PaymentIntent
  state?: PaymentState
}

interface CourtBooking {
  __typename: 'CourtBooking'
  bookableItem: CourtBookableItem
}

export enum OrderState {
  ORDER_STATE_OPEN = 'ORDER_STATE_OPEN',
  ORDER_STATE_CONFIRMED = 'ORDER_STATE_CONFIRMED',
  ORDER_STATE_ABORTED = 'ORDER_STATE_ABORTED',
}

interface EventBooking {
  __typename: 'EventBooking'
  bookableItem: EventBookableItem
}

type Booking = CourtBooking | EventBooking

interface BookingOrderItem {
  __typename: 'BookingOrderItem'
  booking: Booking
}

interface AssignedProductOrderItem {
  __typename: 'AssignedProductOrderItem'
  assignedProduct: AssignedProduct
}

type Item = BookingOrderItem | AssignedProductOrderItem

export default Order
